const headList = [
  { headTitle: "同意日" },
  { headTitle: "共済契約者番号" },
  { headTitle: "共済契約者名" },
];

const tableTitle = "情報提供に同意いただいている共済契約者一覧";

export { headList, tableTitle };
